import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface AuthState {
  token: string | null;
  user: any | null;
  canAccessOtp: boolean;
  isLoggedIn: boolean;
}

const initialState: AuthState = {
  token: null,
  user: null,
  canAccessOtp: false,
  isLoggedIn: false
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    loginSuccess: (state, action: PayloadAction<any>) => {
      state.token = action.payload.token;
      state.user = action.payload.user;
      state.isLoggedIn = true
    },
    logout: (state) => {
      state.token = null;
      state.user = null;
      state.canAccessOtp = false;
      state.isLoggedIn = false;
    },
    setCanAccessOtp: (state, action: PayloadAction<boolean>) => {
      state.canAccessOtp = action.payload;
    },
  },
});

export const { loginSuccess, logout, setCanAccessOtp } = authSlice.actions;
export default authSlice.reducer;
